import { createReducer } from 'redux-act';
import { Urls } from 'kts-platform-frame/entry/constant';
import ActionTypes from './ActionTypes';
import { IAppInfo } from 'kts-platform-frame/dataModel';
import sharedObject from 'kts-platform-frame/sharedObject';
import Node from './Node';

const reducer = createReducer(
    {
        [ActionTypes.addLoading as any]: (state: Node, url: Urls) => {
            const loadingUrls = new Map<Urls, string>(state.loadingUrls.entries());
            loadingUrls.set(url, url);
            const system = {
                ...state,
                loadingUrls: loadingUrls,
            };

            const loading: string[] = [];
            loadingUrls.forEach(value => {
                loading.push(value);
            });
            sharedObject.set('$$/system/loading', JSON.stringify(loading));

            return system;
        },

        [ActionTypes.removeLoading as any]: (state: Node, url: Urls) => {

            const loadingUrls = new Map<Urls, string>(state.loadingUrls.entries());
            loadingUrls.delete(url);
            const system = {
                ...state,
                loadingUrls: loadingUrls,
            };

            const loading: string[] = [];
            loadingUrls.forEach(value => {
                loading.push(value);
            });
            sharedObject.set('$$/system/loading', JSON.stringify(loading));

            return system;
        },

        [ActionTypes.updateUnread as any]: (state: Node, payload: number) => {
            const system = {
                ...state,
                messageUnread: payload
            };
            return system;
        },

        [ActionTypes.updateMenuAppList as any]: (state: Node, payload: IAppInfo[]) => {
            const system = {
                ...state,
                menuAppList: payload
            };
            return system;
        },

        [ActionTypes.addLanguageVersion as any]: (state: Node) => {
            const system = {
                ...state,
                languageVersion: new Date().getTime().toString(16)+Math.random().toString(16)
            };

            sharedObject.set('$$/system/languageVersion', system.languageVersion);
            
            return system;
        },

        [ActionTypes.setVersion as any]: (state: Node, version) => {
            const system = {
                ...state,
                version
            };
            
            sharedObject.set('$$/system/version', version);

            return system;
        },

        [ActionTypes.setLoginType as any]: (state: Node, loginType) => {
            const system = {
                ...state,
                loginType
            };

            return system;
        },
    },
    new Node()
);

export default reducer;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/redux/reducers/system/reducer.ts